import QuizzApp from "./QuizApp";

export default function App() {
  return <QuizzApp />;
}
